import React from 'react'
import { AttachmentLink } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'
import { Block, BlockRow, Text } from '@pandiafi/components'

import { Section } from '../../../components'
import { FeedbackAndQuestionNoticeDetails } from '../../../../common/validations/feedbackAndQuestionNotice'
import { User } from '../../../../common/validations'

import { CardTitleBand } from 'components/CardTitleBand/CardTitleBand'

interface QuestionViewProps {
  existingNotice?: FeedbackAndQuestionNoticeDetails
  user: User
}

export const QuestionDetailView: React.FC<QuestionViewProps> = ({
  existingNotice,
  user,
}) => {
  const { t } = useTranslation(['common', 'question'])

  const { title, description, files } = existingNotice || {}

  return (
    <>
      <CardTitleBand>{t('question:headings.questionDetail')}</CardTitleBand>
      <Section className="mb-12">
        <Block>
          <BlockRow>
            <Text element="p">{user.email}</Text>
            <Text element="p">{user.phoneNumber}</Text>
          </BlockRow>
          <BlockRow>
            <Text element="h2" size="xl" weight="medium">
              {title}
            </Text>
          </BlockRow>
          <BlockRow>
            <Text element="p" className="hyphens-auto [overflow-wrap:anywhere]">
              {description}
            </Text>
          </BlockRow>
          {files && files.length > 0 && (
            <>
              <BlockRow>
                <Text element="h3" size="m" weight="medium">
                  {t('question:labels.files')}:
                </Text>
              </BlockRow>
              {files.map((file) => (
                <BlockRow key={file.uuid || file.fileName}>
                  <AttachmentLink
                    text={file.fileName || `${t('common:file')}`}
                    icon="paperclip"
                    disabled
                  />
                </BlockRow>
              ))}
            </>
          )}
        </Block>
      </Section>
    </>
  )
}
